{
  "dashboard": "Dashibodi ya Msanidi",
  "projects": "Miradi",
  "reports": "Ripoti",
  "credits": "Mikopo",
  "dashboard_page": {
    "title": "Dashibodi ya Mtengenezaji wa Mradi",
    "subtitle": "Simamia miradi yako ya mikopo ya kaboni na fuatilia maendeleo ya uwasilishaji",
    "stats": {
      "registered_projects": "Miradi Iliyosajiliwa",
      "pending_reviews": "Ukaguzi Unaongoja",
      "issued_credits": "Mikopo Iliyotolewa",
      "total_revenue": "Mapato Jumla"
    },
    "quick_actions": {
      "title": "Vitendo vya Haraka",
      "submit_pin": "Wasilisha PIN",
      "submit_pin_desc": "Dokezo la Wazo la Mradi",
      "submit_pdd": "Wasilisha PDD",
      "submit_pdd_desc": "Hati ya Muundo wa Mradi",
      "upload_reports": "Pakia Ripoti",
      "upload_reports_desc": "Ufuatiliaji na Uthibitishaji",
      "browse_registry": "Vinjari Rejista",
      "browse_registry_desc": "Chunguza Miradi",
      "request_credits": "Omba Mikopo",
      "request_credits_desc": "Utoaji wa Mikopo",
      "legacy_registration": "Usajili wa Urithi",
      "legacy_registration_desc": "Dosari ya Utii",
      "view_projects": "Ona Miradi",
      "view_projects_desc": "Simamia Kundi"
    },
    "recent_activity": {
      "title": "Shughuli za Hivi Karibuni",
      "pin_submitted": "PIN imewasilishwa kwa Shamba la Upepo Alpha",
      "pin_submitted_time": "masaa 2 yaliyopita",
      "pdd_approved": "PDD imeidhinishwa kwa Mradi wa Jua Beta",
      "pdd_approved_time": "siku 1 iliyopita",
      "credits_issued": "Mikopo imetolewa kwa Uhifadhi wa Misitu Gamma",
      "credits_issued_time": "siku 3 zilizopita"
    },
    "project_pipeline": {
      "title": "Mfumo wa Miradi",
      "idea_stage": "Hatua ya Wazo",
      "design_stage": "Hatua ya Muundo",
      "validation_stage": "Hatua ya Uthibitishaji",
      "implementation_stage": "Hatua ya Utekelezaji",
      "monitoring_stage": "Hatua ya Ufuatiliaji"
    },
    "recent_projects": {
      "title": "Miradi ya Hivi Karibuni",
      "view_all": "Ona Zote"
    },
    "pending_tasks": {
      "title": "Kazi Zinazongoja",
      "urgent": "Za Haraka",
      "doe_selection_required": "Uchaguzi wa DOE Unahitajika",
      "doe_selection_desc": "Shamba la Upepo Alpha - Chagua DOE ndani ya siku 5",
      "monitoring_report_due": "Ripoti ya Ufuatiliaji Imechelewa",
      "monitoring_report_desc": "Shamba la Jua Beta - Uwasilishaji wa RMR unahitajika",
      "payment_pending": "Malipo Yamengojwa",
      "payment_pending_desc": "Ada ya kuwasilisha PDD - $1,500.00"
    },
    "notifications": {
      "title": "Arifa za Hivi Karibuni",
      "pin_review_completed": "Ukaguzi wa PIN Umekamilika",
      "pin_review_desc": "Shamba la Upepo Alpha limeidhinishwa. Sasa unaweza kuwasilisha PDD.",
      "doe_assignment": "Mgao wa DOE",
      "doe_assignment_desc": "GreenAudit Ltd imepangiwa kuwa DOE kwa uthibitisho wa Shamba la Jua Beta.",
      "system_maintenance": "Matengenezo ya Mfumo",
      "system_maintenance_desc": "Matengenezo yaliyopangwa mnamo Des 20, 2024 kutoka saa 2:00-4:00 UTC.",
      "time_2_hours_ago": "masaa 2 yaliyopita",
      "time_1_day_ago": "siku 1 iliyopita",
      "time_3_days_ago": "siku 3 zilizopita"
    }
  },
  "register_page": {
    "title": "Usajili wa Mtengenezaji wa Mradi",
    "subtitle": "Kamilisha usajili wako ili kuwasilisha miradi na kusimamia mizunguko ya mikopo ya kaboni",
    "form_title": "Fomu ya Usajili",
    "form_subtitle": "Tafadhali toa taarifa sahihi kwa ajili ya uthibitishaji",
    "registration_fee": "Ada ya Usajili",
    "organization_info": {
      "title": "Taarifa za Shirika",
      "legal_name": "Jina la Kisheria la Shirika",
      "legal_name_placeholder": "Ingiza jina la kisheria la shirika lako",
      "business_type": "Aina ya Biashara",
      "select_type": "Chagua aina ya biashara",
      "registration_number": "Nambari ya Usajili",
      "registration_number_placeholder": "Nambari ya usajili wa biashara",
      "country": "Nchi ya Usajili",
      "select_country": "Chagua nchi",
      "address": "Anwani ya Biashara",
      "address_placeholder": "Anwani kamili ya biashara",
      "website": "Tovuti",
      "website_placeholder": "https://www.mfano.com"
    },
    "contact_info": {
      "title": "Taarifa za Mawasiliano",
      "primary_contact": "Mtu wa Mawasiliano wa Msingi",
      "primary_contact_placeholder": "Jina kamili la mtu wa mawasiliano wa msingi",
      "job_title": "Cheo cha Kazi",
      "job_title_placeholder": "Nafasi katika shirika",
      "email": "Anwani ya Barua pepe",
      "email_placeholder": "mawasiliano{'@'}mfano.com",
      "phone": "Nambari ya Simu",
      "phone_placeholder": "+1 (555) 123-4567",
      "alternative_contact": "Mwasiliani Mbadala",
      "alternative_contact_placeholder": "Mtu wa mawasiliano wa kuhifadhia"
    },
    "project_focus": {
      "title": "Maeneo ya Mkakati wa Miradi",
      "renewable_energy": "Nishati Inayoweza Kurejeshwa",
      "renewable_energy_desc": "Miradi ya nguvu za jua, upepo, maji",
      "energy_efficiency": "Ufanisi wa Nishati",
      "energy_efficiency_desc": "Ufanisi wa majengo na viwanda",
      "afolu": "AFOLU",
      "afolu_desc": "Kilimo, misitu, matumizi ya ardhi",
      "waste_management": "Usimamizi wa Taka",
      "waste_management_desc": "Matibabu na kutupa taka",
      "transport": "Usafiri",
      "transport_desc": "Usafiri endelevu",
      "other": "Nyingine",
      "other_desc": "Shughuli nyingine za kupunguza kaboni"
    },
    "declarations": {
      "title": "Matamko na Utii",
      "agree_terms": "Ninakubali",
      "terms_conditions": "Masharti na Hali",
      "acknowledge_privacy": "Natambua",
      "privacy_policy": "Sera ya Faragha",
      "comply_standards": "Ninakubali kutii viwango na mbinu za Rejista ya SOR",
      "accurate_info": "Ninatamka kuwa taarifa zote zilizotolewa ni sahihi na kamili",
      "legal_authority": "Nina mamlaka ya kisheria ya kusajili kwa niaba ya shirika hili"
    },
    "payment_info": {
      "title": "Taarifa za Malipo",
      "registration_fee_info": "Ada ya usajili wa $1,000.00 inahitajika kukamilisha usajili",
      "fee_includes": "Ada inajumuisha usanidi wa akaunti, ushauri wa mradi wa kwanza, na msaada unaoendelea",
      "payment_methods": "Njia za malipo zinazokubaliwa: Kadi ya mkopo, uhamisho wa benki, sarafu za kidijitali"
    },
    "form_actions": {
      "submit_registration": "Wasilisha Usajili ($1,000.00)",
      "cancel": "Ghairi",
      "back_to_portal": "Rudi kwenye Tovuti",
      "save_draft": "Hifadhi Muswada",
      "submit_pay": "Wasilisha na Lipa $1,000.00"
    },
    "form_fields": {
      "organization_info": "Taarifa za Shirika",
      "full_name_org": "Jina Kamili / Jina la Shirika",
      "full_name_org_placeholder": "Ingiza jina la shirika",
      "business_registration_number": "Nambari ya Usajili wa Biashara/Kampuni",
      "business_registration_placeholder": "mf., ABN, EIN, Nambari ya Kampuni, Nambari ya VAT",
      "legal_status": "Hali ya Kisheria",
      "select_legal_status": "Chagua hali ya kisheria",
      "corporation": "Shirika",
      "llc": "Kampuni ya Uwajibikaji Mdogo",
      "partnership": "Ushirikiano",
      "non_profit": "Shirika la Kijamii",
      "government_entity": "Chombo cha Serikali",
      "country_incorporation": "Nchi ya Kuanzishwa",
      "select_country": "Chagua nchi",
      "united_states": "Marekani",
      "united_kingdom": "Uingereza",
      "canada": "Kanada",
      "germany": "Ujerumani",
      "france": "Ufaransa",
      "other": "Nyingine",
      "contact_information": "Taarifa za Mawasiliano",
      "physical_address": "Anwani ya Kimwili",
      "physical_address_placeholder": "Ingiza anwani kamili ya kimwili",
      "contact_email": "Barua Pepe ya Mawasiliano",
      "contact_email_placeholder": "mawasiliano{'@'}shirika.com",
      "phone_number": "Nambari ya Simu",
      "phone_placeholder": "+1 (555) 123-4567",
      "local_representative": "Mwakilishi wa Ndani (kama ni chombo cha kigeni)",
      "representative_name": "Jina la Mwakilishi",
      "representative_name_placeholder": "Jina kamili",
      "representative_email": "Barua Pepe ya Mwakilishi",
      "representative_email_placeholder": "mwakilishi{'@'}barua.com",
      "declarations_terms": "Matamko na Masharti",
      "accuracy_declaration": "Natamka kuwa taarifa zote zilizopatikana ni sahihi na kamili kwa kadri ya ujuzi wangu.",
      "compliance_agreement": "Ninakubali kufuata mahitaji na kanuni zote za Daftari la SOR.",
      "terms_acceptance": "Nimesoma na ninakubali",
      "terms_service": "Masharti ya Huduma",
      "and": "na",
      "privacy_policy": "Sera ya Faragha",
      "fee_acknowledgment": "Ninakiri ada ya usajili ya $1,000.00 na ada zoyote za utunzaji zinazotumika."
    },
    "info_boxes": {
      "what_happens_next": {
        "title": "Nini kinachofuata?",
        "review_time": "Ukaguzi wa ombi ndani ya siku 5-7 za kazi",
        "din_generation": "Uundaji wa Nambari ya Utambulisho wa Mwendelezaji (DIN)",
        "email_verification": "Uthibitishaji wa barua pepe na usanidi wa MFA",
        "portal_access": "Ufikiaji wa tovuti ya kuwasilisha mradi"
      },
      "secure_compliant": {
        "title": "Salama na Inayofuata Sheria",
        "encryption": "Usimbaji fiche wa mwisho hadi mwisho kwa upakiaji wote",
        "gdpr_compliant": "Inafuata GDPR na ulinzi wa data",
        "audit_trail": "Njia ya ukaguzi kwa miamala yote",
        "security_monitoring": "Ufuatiliaji wa usalama saa 24/7"
      }
    }
  },
  "sidebar": {
    "dashboard": "Dashibodi",
    "project_ideas": "Mawazo ya Miradi",
    "design_documents": "Nyaraka za Muundo",
    "monitoring_reports": "Ufuatiliaji na Ripoti",
    "credit_issuance": "Utoaji wa Mikopo",
    "browse_registry": "Vinjari Rejista",
    "legacy_projects": "Miradi ya Urithi",
    "help_support": "Msaada na Uongozi",
    "settings": "Mipangilio",
    "logout": "Toka"
  },
  "project": {
    "submit_pin": {
      "title": "Wasilisha Dokezo la Wazo la Mradi (PIN)",
      "subtitle": "Toa maelezo ya awali ya mradi kwa tathmini na usindikaji wa Barua ya Kutokukataza (LNO).",
      "submission_fee": "Ada ya Uwasilishaji: $500.00",
      "review_sla": "SLA ya siku 30 kwa ukaguzi",
      "auto_categorized": "Umegawanywa kiotomatiki baada ya kuwasilishwa",
      "developer_id": "Kitambulisho cha Mtengenezaji",
      "save_draft": "Hifadhi kama Rasimu",
      "project_details": {
        "title": "Maelezo ya Mradi",
        "project_name": "Jina la Mradi",
        "project_name_placeholder": "Ingiza jina la mradi",
        "project_type": "Aina ya Mradi",
        "select_type": "Chagua aina ya mradi",
        "project_summary": "Muhtasari wa Mradi",
        "project_summary_placeholder": "Toa muhtasari mkuu wa mradi ikijumuisha malengo, mbinu, na matokeo yanayotarajiwa",
        "project_scope": "Uwanda na Mipaka ya Mradi",
        "project_scope_placeholder": "Bainisha mipaka ya kimwili na ya muda ya mradi",
        "types": {
          "afforestation": "Upandaji/Upandaji Upya wa Misitu",
          "forest_management": "Usimamizi wa Misitu",
          "renewable_energy": "Nishati Inayoweza Kurejeshwa",
          "energy_efficiency": "Ufanisi wa Nishati",
          "waste_management": "Usimamizi wa Taka",
          "agriculture": "Kilimo"
        }
      },
      "location": {
        "title": "Eneo na Taarifa za Kijiografia",
        "country": "Nchi",
        "select_country": "Chagua nchi",
        "state_province": "Jimbo/Mkoa",
        "state_province_placeholder": "Ingiza jimbo au mkoa",
        "location_description": "Maelezo ya Kina ya Eneo",
        "location_description_placeholder": "Toa taarifa za kina za eneo ikijumuisha miji ya karibu, alama za ardhi, au vipengele vya kijiografia",
        "gps_latitude": "Kuratibu za GPS (Latitude)",
        "gps_latitude_placeholder": "mfano: 40.7128",
        "gps_longitude": "Kuratibu za GPS (Longitude)",
        "gps_longitude_placeholder": "mfano: -74.0060",
        "interactive_map": "Ramani ya GIS ya Mwingiliano itaonekana hapa",
        "upload_kml": "Pakia KML/Shapefile"
      },
      "emissions": {
        "title": "Makadirio ya Kupunguza Uchafuzi",
        "annual_reduction": "Kupunguza Uchafuzi kwa Mwaka (tCO2e)",
        "project_duration": "Muda wa Mradi (miaka)",
        "total_reduction": "Jumla ya Kupunguza Kinachotarajiwa (tCO2e)",
        "auto_calculated": "Imehesabiwa kiotomatiki",
        "methodology": "Mbinu na Mkabala wa Mahesabu",
        "methodology_placeholder": "Elezea mbinu iliyotumiwa kwa mahesabu ya kupunguza uchafuzi"
      },
      "uploads": {
        "title": "Upakiaji wa Nyaraka Zinazohitajika",
        "npramp": "Tathmini ya Hatari ya Kutokudumu na Mpango wa Kukabiliana (NPRAMP)",
        "ehmf": "Fomu ya Usimamizi wa Uharibifu wa Mazingira (EHMF)",
        "spcp": "Mpango wa Ushauri wa Wadau na Umma (SPCP)",
        "fpic": "Idhini Huru, ya Awali na ya Kutaarifiwa (FPIC)",
        "financial": "Pendekezo la Awali la Kifedha",
        "required": "Inahitajika",
        "upload_text": "Bofya ili kupakia au buruta na udondoshe",
        "file_types_doc": "PDF, DOC, DOCX hadi 10MB",
        "file_types_finance": "PDF, XLS, XLSX hadi 10MB"
      },
      "declarations": {
        "title": "Matamko na Uthibitisho",
        "accurate_info": "Ninathibitisha kuwa taarifa zote zilizotolewa ni sahihi na kamili kwa kadri ya ujuzi wangu.",
        "false_info_penalty": "Ninaelewa kuwa uwasilishaji wa taarifa za uongo au za kupotoza unaweza kusababisha kukataliwa na adhabu zinazowezekana.",
        "fee_agreement": "Ninakubali ada ya uwasilishaji wa PIN ya $500.00 na ninaelewa haiwezi kurudishwa bila kujali matokeo.",
        "review_period": "Ninakiri kipindi cha ukaguzi wa siku 30 na ninakubali kutoa taarifa ya ziada ikiombolewa."
      },
      "actions": {
        "save_draft": "Hifadhi Rasimu",
        "preview": "Hakikisha",
        "submission_fee_label": "Ada ya Uwasilishaji:",
        "payment_processed": "Malipo yanasindikwa wakati wa uwasilishaji",
        "submit_pin": "Wasilisha PIN"
      }
    },
    "submit_pdd": {
      "breadcrumb": {
        "dashboard": "Dashibodi",
        "projects": "Miradi",
        "submit_pdd": "Wasilisha PDD"
      },
      "title": "Wasilisha Hati ya Muundo wa Mradi",
      "subtitle": "Kamilisha uwasilishaji wako wa PDD na taarifa zilizojazwa kiotomatiki kutoka kwa PIN yako iliyoidhinishwa",
      "status_draft": "Rasimu",
      "project_info": {
        "title": "Taarifa za Mradi",
        "auto_filled": "Imejazwa kiotomatiki kutoka kwa PIN iliyoidhinishwa",
        "auto_filled_description": "Taarifa zifuatazo zimejazwa kiotomatiki kutoka kwa Dokezo lako la Wazo la Mradi lililoidhinishwa (PIN-2024-001).",
        "project_title": "Kichwa cha Mradi",
        "project_category": "Jamii ya Mradi",
        "location": "Eneo",
        "estimated_credits": "Mikopo Inayokadiriwa (tCO2e)",
        "developer_id": "Kitambulisho cha Mtengenezaji",
        "pin_reference": "Rejeleo la PIN",
        "submission_date": "Tarehe ya Uwasilishaji"
      },
      "doe_selection": {
        "title": "Chombo Kilichoteuliwa cha Uendeshaji (DOE)",
        "required_message": "Uchaguzi wa DOE Unahitajika",
        "description": "Chagua DOE iliyohitimu kwa sekta yako ya mradi. Mfumo utaangalia kiotomatiki migogoro ya maslahi.",
        "project_sector": "Sekta ya Mradi",
        "select_doe": "Chagua DOE *",
        "choose_doe_placeholder": "Chagua DOE...",
        "doe_options": {
          "ecoverify": "EcoVerify International - Mtaalamu wa Misitu",
          "carbon_audit": "Carbon Audit Solutions - Imethibitishwa AFOLU",
          "green_validation": "Green Validation Corp - Sekta Mbalimbali",
          "forest_carbon": "Forest Carbon Assessors - Mtaalamu wa REDD+"
        },
        "conflict_check": {
          "title": "Ukaguzi wa Migogoro ya Maslahi",
          "description": "Mfumo utathibitisha kiotomatiki kuwa hakuna migogoro kati ya shirika lako na DOE iliyochaguliwa."
        }
      },
      "documents": {
        "title": "Nyaraka Zinazohitajika",
        "positive_validation_report": {
          "title": "Ripoti Chanya ya Uthibitisho",
          "description": "Kutoka DOE iliyochaguliwa"
        },
        "required_status": "Inahitajika",
        "upload_text": "Dondosha faili hapa au bofya kuvinjari",
        "choose_file": "Chagua Faili",
        "updated_npramp": {
          "title": "NPRAMP Iliyosasishwa",
          "description": "Tathmini ya Hatari ya Kutokudumu"
        },
        "auto_filled_status": "Imejazwa kiotomatiki",
        "updated_ehmf": {
          "title": "EHMF Iliyosasishwa",
          "description": "Usimamizi wa Madhara ya Mazingira"
        },
        "long_term_financial_proposal": {
          "title": "Pendekezo la Kifedha la Muda Mrefu",
          "description": "Makadirio ya kina ya kifedha"
        }
      },
      "actions": {
        "save_draft": "Hifadhi Muswada",
        "preview": "Hakikisha",
        "cancel": "Ghairi",
        "submit_pdd": "Wasilisha PDD ($1,500)"
      },
      "sidebar": {
        "progress_card": {
          "title": "Maendeleo ya Uwasilishaji",
          "pin_approved": {
            "title": "PIN Imeidhinishwa"
          },
          "pdd_submission": {
            "title": "Uwasilishaji wa PDD",
            "status": "Inaendelea"
          },
          "doe_validation": {
            "title": "Uthibitisho wa DOE",
            "status": "Inasubiri"
          }
        },
        "timeline_card": {
          "title": "Tarehe Muhimu za Mwisho",
          "pdd_deadline": {
            "title": "Tarehe ya Mwisho ya PDD",
            "description": "Miezi 18 kutoka LNO"
          },
          "doe_selection": {
            "title": "Uchaguzi wa DOE",
            "description": "Ndani ya siku 30"
          }
        },
        "help_card": {
          "title": "Unahitaji Msaada?",
          "description": "Pata msaada kwa uwasilishaji wako wa PDD",
          "contact_support": "Wasiliana na Msaada",
          "view_guide": "Ona Mwongozo"
        }
      }
    }
  },
  "browse_registry": {
    "title": "Kichunguzi cha Daftari",
    "subtitle": "Vinjari miradi, fuatilia mikopo, na toa ripoti zinazoweza kuhamishwa",
    "export_report": "Hamisha Ripoti",
    "advanced_filter": "Kichujio cha Juu",
    "search_placeholder": "Tafuta miradi...",
    "filters": {
      "all_categories": "Makundi Yote",
      "all_status": "Hali Zote",
      "all_proponents": "Wapendekezaji Wote",
      "article6_eligible": "Inastahiki Kifungu cha 6",
      "clear": "Futa"
    },
    "stats": {
      "total_projects": "Jumla ya Miradi",
      "credits_issued": "Mikopo Iliyotolewa",
      "credits_retired": "Mikopo Iliyostaafishwa",
      "buffer_credits": "Mikopo ya Akiba",
      "active_transfers": "Uhamisho Unaotumika"
    },
    "projects_table": {
      "title": "Miradi Inayoendelea"
    },
    "credit_tracking": {
      "recent_transactions": {
        "title": "Miamala ya Hivi Karibuni ya Mikopo",
        "credits_issued": "Mikopo Iliyotolewa",
        "credits_transferred": "Mikopo Iliyohamishwa",
        "credits_retired": "Mikopo Iliyostaafishwa"
      },
      "generate_reports": {
        "title": "Toa Ripoti"
      }
    }
  },
  "request_credits": {
    "title": "Utoaji wa Mikopo ya Kaboni",
    "subtitle": "Simamia maombi ya utoaji wa mikopo, malipo ya ada, na makato ya lazima",
    "new_issuance_request": "Ombi Jipya la Utoaji",
    "credit_issuance_request": {
      "title": "Ombi la Utoaji wa Mikopo",
      "subtitle": "Wasilisha hati za uthibitisho kwa utoaji wa mikopo",
      "project_name": "Jina la Mradi",
      "select_project": "Chagua Mradi",
      "certificate_registration": "Cheti cha Usajili",
      "monitoring_period_start": "Mwanzo wa Kipindi cha Ufuatiliaji",
      "monitoring_period_end": "Mwisho wa Kipindi cha Ufuatiliaji",
      "requested_credits": "Mikopo Iliyoombwa kwa Utoaji",
      "credits_placeholder": "Ingiza idadi ya mikopo"
    },
    "required_documents": {
      "title": "Nyaraka Zinazohitajika",
      "doe_verification": "Ripoti ya Uthibitisho wa DOE",
      "monitoring_reports": "Ripoti za Ufuatiliaji",
      "ics_certificates": "Vyeti vya Utoaji vya ICS (ikiwa inatumika)",
      "legacy_projects_only": "Kwa miradi ya urithi pekee",
      "upload_pdf": "Pakia faili ya PDF (Upeo 10MB)",
      "upload_multiple": "Pakia faili nyingi (Upeo 10MB kila moja)",
      "choose_file": "Chagua Faili",
      "choose_files": "Chagua Faili"
    },
    "issuance_summary": {
      "title": "Muhtasari wa Utoaji",
      "requested_credits": "Mikopo Iliyoombwa",
      "mandatory_deductions": {
        "title": "Makato ya Lazima",
        "ndc_retirement": "Kustaafu kwa NDC (1%)",
        "buffer_account": "Akaunti ya Akiba (2%)",
        "transaction_account": "Akaunti ya Muamala (30%)"
      },
      "net_credits": "Mikopo Safi ya Kutolewa"
    },
    "fee_calculation": {
      "title": "Hesabu ya Ada",
      "cci_certificate_fee": "Ada ya Cheti cha CCI",
      "credit_issuance_fee": "Ada ya Utoaji wa Mikopo",
      "total_fee": "Jumla ya Ada",
      "proceed_payment": "Endelea na Malipo"
    },
    "processing_timeline": {
      "title": "Muda wa Usindikaji",
      "message": "Utoaji wa mikopo kwa kawaida huchukua siku 5-7 za kazi baada ya uthibitisho wa malipo na uthibitisho wa hati."
    },
    "recent_issuances": {
      "title": "Maombi ya Hivi Karibuni ya Utoaji",
      "columns": {
        "request_id": "Kitambulisho cha Ombi",
        "project": "Mradi",
        "credits": "Mikopo",
        "fee": "Ada",
        "status": "Hali",
        "date": "Tarehe",
        "actions": "Vitendo"
      },
      "status": {
        "all": "Hali Zote",
        "completed": "Imekamilika",
        "processing": "Inasindika",
        "pending": "Inasubiri",
        "rejected": "Imekataliwa"
      }
    }
  },
  "upload_reports": {
    "breadcrumb": {
      "dashboard": "Dashibodi",
      "project_management": "Usimamizi wa Mradi",
      "monitoring_reporting": "Ufuatiliaji na Uripoti"
    },
    "title": "Pakia Ripoti za Ufuatiliaji",
    "subtitle": "Wasilisha ripoti za ufuatiliaji na utii zinazohitajika kwa miradi yako iliyoidhinishwa",
    "project_id": "Kitambulisho cha Mradi",
    "project_name": "Uhifadhi wa Misitu Beta",
    "progress": {
      "project_registered": "Mradi Umesajiliwa",
      "upload_reports": "Pakia Ripoti",
      "verification": "Uthibitisho",
      "credit_issuance": "Utoaji wa Mikopo",
      "next_deadline": "Tarehe ijayo ya mwisho:"
    },
    "required_documents_title": "Nyaraka za Ufuatiliaji Zinazohitajika",
    "rmr": {
      "title": "Ripoti ya Ufuatiliaji wa Kawaida (RMR)",
      "description": "Wasilisha takwimu za ufuatiliaji wa kila robo ikijumuisha mapunguzo ya uzalishaji, shughuli za mradi, na madhara ya mazingira.",
      "drop_text": "Dondosha faili yako ya RMR hapa"
    },
    "required_documents": {
      "rmr": {
        "browse_text": "au bofya kuvinjari faili"
      },
      "sdr": {
        "title": "Ripoti ya Maendeleo Endelevu (SDR)",
        "description": "Andika mchango kwenye malengo ya maendeleo endelevu na faida za jamii.",
        "drop_text": "Dondosha faili yako ya SDR hapa"
      },
      "verification": {
        "title": "Ripoti ya Uthibitisho wa Mtu wa Tatu",
        "description": "Ripoti ya uthibitisho huru na DOE iliyoidhinishwa kwa utoaji wa mikopo.",
        "drop_text": "Dondosha ripoti ya uthibitisho hapa"
      },
      "reversal": {
        "title": "Ripoti ya Tukio la Kurejesha",
        "description": "Inahitajika tu ikiwa kurudi kwa uzalishaji kumetokea. Andika ongezeko lolote lisilokusudiwa la GHG.",
        "drop_text": "Dondosha nyaraka za tukio la kurejesha hapa",
        "only_if_applicable": "Tu ikiwa inatumika"
      },
      "browse_files": "Vinjari Faili",
      "file_support": "Inasaidiwa: PDF, DOC, DOCX (Juu zaidi 25MB)"
    },
    "status_labels": {
      "required": "Inahitajika",
      "optional": "Si Lazima",
      "conditional": "Kwa Masharti",
      "submitted": "Imewasilishwa",
      "approved": "Imeidhinishwa",
      "pending": "Inasubiri"
    },
    "confirmation": {
      "title": "Nathibitisha kuwa nyaraka zote zilizopakiwa ni sahihi na kamili",
      "save_draft": "Hifadhi Muswada",
      "submit_reports": "Wasilisha Ripoti"
    },
    "guidelines": {
      "title": "Miongozo ya Kupakia",
      "english_translations": "Nyaraka zote lazima ziwe kwa Kiingereza au zijumuishe tafsiri zilizothibitishwa",
      "naming_convention": "Faili zinapaswa kupewa majina yenye kitambulisho cha mradi na aina ya nyaraka",
      "max_file_size": "Ukubwa wa juu wa faili: 25MB kwa nyaraka",
      "digital_signatures": "Saini za kidijitali zinahitajika kwa ripoti za uthibitisho"
    },
    "submission_status": {
      "title": "Hali ya Uwasilishaji"
    },
    "help": {
      "title": "Unahitaji Msaada?",
      "subtitle": "Pata violezo na miongozo kwa ripoti za ufuatiliaji",
      "rmr_template": "Kiolezo cha RMR",
      "sdr_guidelines": "Miongozo ya SDR",
      "contact_support": "Wasiliana na Msaada"
    },
    "sample_data": {
      "deadline_date": "Des 31, 2024",
      "rmr_q3_2024": "RMR R3 2024",
      "sdr_2024": "SDR 2024",
      "rmr_q4_2024": "RMR R4 2024"
    }
  },
  "legacy_registration": {
    "title": "Usajili wa Mradi wa Urithi",
    "subtitle": "Sajili miradi iliyopo kutoka viwango vingine (ICS, CDM, VCS) kwenda Daftari la SOR",
    "standards": {
      "ics_migration": "Uhamishaji wa ICS",
      "cdm_transition": "Mpito wa CDM",
      "vcs_compliance": "Utii wa VCS"
    },
    "registration_form": {
      "title": "Fomu ya Usajili wa Urithi",
      "subtitle": "Jaza sehemu zote zinazohitajika na upakia nyaraka zinazohitajika kwa usajili wa mradi wa urithi",
      "project_identification": {
        "title": "Maelezo ya Mradi",
        "project_name": "Jina la Mradi*",
        "project_name_placeholder": "Ingiza jina kamili la mradi",
        "project_type": "Jamii ya Mradi*",
        "previous_standard": "Kiwango cha Awali*",
        "project_location": "Eneo la Mradi*",
        "project_description": "Maelezo ya Mradi*"
      },
      "project_details": {
        "select_category": "Chagua Jamii",
        "category_1": "Jamii ya 1 - Ukubwa Mkubwa",
        "category_2": "Jamii ya 2 - Ukubwa wa Kati",
        "category_3": "Jamii ya 3 - Ukubwa Mdogo",
        "select_previous_standard": "Chagua Kiwango cha Awali",
        "ics_standard": "ICS (Kiwango cha Kaboni cha Kimataifa)",
        "cdm_standard": "CDM (Utaratibu wa Maendeleo Safi)",
        "vcs_standard": "VCS (Kiwango cha Kaboni Kilichothibitishwa)",
        "other_standard": "Kingine",
        "location_placeholder": "Nchi, Mkoa",
        "description_placeholder": "Toa maelezo ya kina ya mradi"
      },
      "document_uploads": {
        "title": "Nyaraka Zinazohitajika",
        "core_documents": "Nyaraka za Kimsingi za Mradi",
        "compliance_documents": "Nyaraka za Utii",
        "pin": {
          "title": "Dokezo la Wazo la Mradi (PIN)*",
          "description": "Nyaraka ya dhana ya awali ya mradi"
        },
        "pdd": {
          "title": "Nyaraka ya Muundo wa Mradi (PDD)*",
          "description": "Muundo wa kina wa mradi na mbinu"
        },
        "doe_validation": {
          "title": "Ripoti ya Uthibitisho wa DOE*",
          "description": "Ripoti ya uthibitisho wa mtu wa tatu"
        },
        "npramp": {
          "title": "NPRAMP*",
          "description": "Tathmini ya Hatari ya Kutokuwa na Kudumu"
        },
        "ehmf": {
          "title": "EHMF*",
          "description": "Usimamizi wa Madhara ya Mazingira"
        },
        "spcp_fpic": {
          "title": "SPCP & FPIC*",
          "description": "Ushauri wa Wadau & FPIC"
        },
        "crediting_proof": {
          "title": "Uthibitisho wa Mikopo ya ICS / Vyeti vya Kiwango cha Awali*",
          "description": "Pakia uthibitisho wa mikopo ya awali au vyeti"
        },
        "financial_proposal": {
          "title": "Pendekezo la Kifedha*",
          "description": "Pakia nyaraka ya pendekezo la kifedha"
        },
        "upload_text": "Bofya kupakia au buruta na udondoshe",
        "file_formats": {
          "pdf_doc_10mb": "PDF, DOC (Juu zaidi 10MB)",
          "pdf_doc_5mb": "PDF, DOC (Juu zaidi 5MB)",
          "pdf_10mb": "PDF (Juu zaidi 10MB)"
        }
      },
      "financial_info": {
        "title": "Maelezo ya Kifedha",
        "application_fee": "Ada ya Ombi: $500.00",
        "fee_description": "Ada hii inashughulikia mchakato wa ukaguzi wa utii kwa usajili wa mradi wa urithi."
      },
      "declarations": {
        "title": "Matamko na Uthibitisho",
        "accurate_documents": "Nathibitisha kuwa nyaraka zote zilizopakiwa ni sahihi na kamili kwa kadri ya ujuzi wangu.",
        "compliance_review": "Naelewa kuwa mradi utapitia ukaguzi wa utii na unaweza kuhitaji nyaraka za ziada.",
        "fee_agreement": "Ninakubali kulipa ada ya ombi la $500.00 wakati wa kuwasilisha.",
        "terms_acceptance": "Ninakubali masharti na hali za Daftari la SOR na taratibu za utii."
      },
      "form_actions": {
        "save_draft": "Hifadhi Muswada",
        "cancel": "Ghairi",
        "submit_pay": "Wasilisha na Lipa $500.00"
      }
    }
  }
}